/* ==========================================================================
   Zooted Brandz — Product Finder data
   ==========================================================================
   EVERYTHING the "Configure Your Experience" tool asks and recommends lives
   in this file. Edit it freely — no other code changes are needed.

   HOW IT WORKS
   ------------
   1. QUESTIONS: each question has an id, a title, an optional hint, whether
      multiple answers are allowed, and a list of options. Each option carries
      "tags" — simple keywords that describe the visitor's preferences.
   2. PRODUCTS: each recommendable product carries its own "tags". After the
      last question, every product is scored by how many of the visitor's
      selected tags it shares (weights below). The top results are shown.
   3. To change images, set "image" to a file you've uploaded in
      Shopify Admin > Content > Files, or a theme asset URL.
   4. Keep wording lifestyle-based. Never add medical or health claims.
   ========================================================================== */

window.ZOOTED_FINDER = {

  /* Scoring weights per question id (higher = matters more) */
  weights: { mood: 2, experience: 2, format: 3, flavor: 1.5, strain: 3 },

  /* Number of recommendations to display */
  maxResults: 3,

  questions: [
    {
      id: 'mood',
      title: 'HOW ARE YOU FEELING TODAY?',
      hint: 'Pick the one that fits best.',
      multiple: false,
      options: [
        { label: 'Ready to unwind', tags: ['relaxing', 'indica', 'smooth'] },
        { label: 'Looking for energy', tags: ['uplifting', 'sativa'] },
        { label: 'Feeling social', tags: ['uplifting', 'social', 'sativa', 'hybrid'] },
        { label: 'Feeling creative', tags: ['uplifting', 'creative', 'sativa'] },
        { label: 'Want something balanced', tags: ['balanced', 'hybrid'] },
        { label: 'Looking for a bold experience', tags: ['strong', 'bold'] },
        { label: 'Just browsing', tags: [] }
      ]
    },
    {
      id: 'experience',
      title: 'WHAT KIND OF EXPERIENCE ARE YOU LOOKING FOR?',
      hint: 'Pick the one that fits best.',
      multiple: false,
      options: [
        { label: 'Uplifting', tags: ['uplifting', 'sativa'] },
        { label: 'Relaxing', tags: ['relaxing', 'indica'] },
        { label: 'Balanced', tags: ['balanced', 'hybrid'] },
        { label: 'Flavor-focused', tags: ['flavor', 'fruity'] },
        { label: 'Strong', tags: ['strong', 'bold'] },
        { label: 'Smooth', tags: ['smooth'] },
        { label: 'Discreet', tags: ['discreet', 'disposables', 'edibles'] },
        { label: 'Long-lasting', tags: ['long-lasting', 'edibles'] }
      ]
    },
    {
      id: 'format',
      title: 'WHICH PRODUCT TYPES DO YOU PREFER?',
      hint: 'Select as many as you like.',
      multiple: true,
      options: [
        { label: 'Pre-Rolls', tags: ['pre-rolls'] },
        { label: 'Disposables', tags: ['disposables'] },
        { label: 'Flower', tags: ['flower'] },
        { label: 'Edibles', tags: ['edibles'] },
        { label: 'Wax & Concentrates', tags: ['concentrates'] }
      ]
    },
    {
      id: 'flavor',
      title: 'WHAT FLAVOR PROFILES DO YOU ENJOY?',
      hint: 'Select as many as you like.',
      multiple: true,
      options: [
        { label: 'Fruity', tags: ['fruity'] },
        { label: 'Citrus', tags: ['citrus'] },
        { label: 'Sweet', tags: ['sweet'] },
        { label: 'Candy', tags: ['candy'] },
        { label: 'Tropical', tags: ['tropical'] },
        { label: 'Berry', tags: ['berry'] },
        { label: 'Creamy', tags: ['creamy'] },
        { label: 'Gas', tags: ['gas'] },
        { label: 'Earthy', tags: ['earthy'] },
        { label: 'Herbal', tags: ['herbal'] },
        { label: 'Minty', tags: ['minty'] },
        { label: 'Dessert', tags: ['dessert'] },
        { label: 'Chocolate', tags: ['chocolate'] }
      ]
    },
    {
      id: 'strain',
      title: 'WHAT STRAIN CATEGORY DO YOU PREFER?',
      hint: 'Pick one.',
      multiple: false,
      options: [
        { label: 'Sativa', tags: ['sativa'] },
        { label: 'Hybrid', tags: ['hybrid'] },
        { label: 'Indica', tags: ['indica'] },
        { label: 'No Preference', tags: [] }
      ]
    }
  ],

  /*
    PRODUCTS
    --------
    url:   link to the product or collection page on this store
    tags:  keywords that this product should match against
    why:   template for the "Why it matched" line. {{answers}} is replaced
           with a readable summary of the visitor's selections.
  */
  products: [
    {
      title: 'Cyber Stix — Sativa',
      category: 'Cyber Stix · 2G Disposable',
      strain: 'Sativa',
      flavors: 'Citrus · Tropical · Fruity',
      description: 'A premium 2G disposable with mesh-coil technology, battery and oil indicators, and a flavor-forward oil lineup. Often selected for upbeat, daytime-style occasions.',
      image: 'placeholder:cyber-stix',
      url: '/collections/cyber-stix',
      tags: ['disposables', 'sativa', 'uplifting', 'social', 'creative', 'citrus', 'tropical', 'fruity', 'flavor', 'discreet', 'smooth']
    },
    {
      title: 'Cyber Stix — Indica',
      category: 'Cyber Stix · 2G Disposable',
      strain: 'Indica',
      flavors: 'Berry · Sweet · Creamy',
      description: 'The flagship 2G disposable in a smooth, wind-down direction. Rechargeable hardware and high-performance airflow with a rich, dessert-leaning flavor profile.',
      image: 'placeholder:cyber-stix',
      url: '/collections/cyber-stix',
      tags: ['disposables', 'indica', 'relaxing', 'smooth', 'berry', 'sweet', 'creamy', 'dessert', 'discreet', 'flavor']
    },
    {
      title: 'Cyber Stix — Hybrid',
      category: 'Cyber Stix · 2G Disposable',
      strain: 'Hybrid',
      flavors: 'Candy · Fruity · Gas',
      description: 'A balanced take on the flagship disposable — premium construction, big flavor, and a profile commonly chosen for any-time-of-day sessions.',
      image: 'placeholder:cyber-stix',
      url: '/collections/cyber-stix',
      tags: ['disposables', 'hybrid', 'balanced', 'candy', 'fruity', 'gas', 'flavor', 'discreet', 'smooth']
    },
    {
      title: 'Sativa Infused Pre-Roll',
      category: '1.25G Infused Pre-Roll',
      strain: 'Sativa',
      flavors: 'Citrus · Tropical',
      description: 'Premium flower infused with live resin and high-terpene extract in a slow-burning 1.25G cone. A bright, high-potency option popular for social occasions.',
      image: 'placeholder:preroll-infused',
      url: '/collections/infused-pre-rolls',
      tags: ['pre-rolls', 'sativa', 'uplifting', 'social', 'creative', 'strong', 'bold', 'citrus', 'tropical', 'gas', 'flavor']
    },
    {
      title: 'Indica Infused Pre-Roll',
      category: '1.25G Infused Pre-Roll',
      strain: 'Indica',
      flavors: 'Berry · Earthy · Gas',
      description: 'Live-resin infused flower in a slow-burning cone built for full flavor and a heavy-hitting, evening-style experience.',
      image: 'placeholder:preroll-infused',
      url: '/collections/infused-pre-rolls',
      tags: ['pre-rolls', 'indica', 'relaxing', 'strong', 'bold', 'berry', 'earthy', 'gas', 'long-lasting']
    },
    {
      title: 'Classic Pre-Roll',
      category: 'Classic Pre-Roll',
      strain: 'Hybrid',
      flavors: 'Earthy · Herbal',
      description: 'Premium small-batch flower in a smooth, consistent everyday pre-roll. A go-to for people who like it classic and convenient.',
      image: 'placeholder:preroll-classic',
      url: '/collections/classic-pre-rolls',
      tags: ['pre-rolls', 'hybrid', 'balanced', 'smooth', 'earthy', 'herbal']
    },
    {
      title: 'Premium Flower',
      category: 'Indoor Small-Batch Flower',
      strain: 'Sativa · Hybrid · Indica',
      flavors: 'Full terpene lineup',
      description: 'Indoor-grown, hand-trimmed, carefully cured flower from premium genetics. For people who want the plant itself, at its best.',
      image: 'placeholder:flower',
      url: '/collections/premium-flower',
      tags: ['flower', 'sativa', 'hybrid', 'indica', 'earthy', 'herbal', 'gas', 'balanced', 'flavor']
    },
    {
      title: '5G Live Resin Baller Bucket',
      category: '5G Concentrate',
      strain: 'Rotating strains',
      flavors: 'Rich terpene profiles',
      description: 'A five-gram, dab-ready live resin format with a rich terpene profile. Built for experienced consumers who want a bold concentrate experience.',
      image: 'placeholder:baller-bucket',
      url: '/collections/baller-buckets',
      tags: ['concentrates', 'strong', 'bold', 'gas', 'flavor', 'long-lasting']
    },
    {
      title: 'Zooted Gummies',
      category: 'Edibles · Gummies',
      strain: 'Hybrid',
      flavors: 'Fruity · Candy · Sweet · Tropical',
      description: 'Flavor-first gummies with clear dosage information on every pack. A discreet, long-lasting-style option commonly chosen for easy sessions.',
      image: 'placeholder:gummies',
      url: '/collections/gummies',
      tags: ['edibles', 'hybrid', 'balanced', 'fruity', 'candy', 'sweet', 'tropical', 'berry', 'discreet', 'long-lasting', 'flavor']
    },
    {
      title: 'Zooted Chocolate',
      category: 'Edibles · Chocolate',
      strain: 'Hybrid',
      flavors: 'Chocolate · Dessert · Creamy',
      description: 'Premium infused chocolate with clean dosing per piece. A dessert-style pick for people who want their session to taste incredible.',
      image: 'placeholder:chocolate',
      url: '/collections/chocolate',
      tags: ['edibles', 'hybrid', 'chocolate', 'dessert', 'creamy', 'sweet', 'discreet', 'long-lasting', 'relaxing']
    }
  ]
};
